export enum Mode {
	Dark = 'Dark',
	Light = 'Light',
}
